define('modules/login/login_view',[
  'backbone',
  'jquery',
  '_',

  'text!./login_template.html',
  'text!./login_forgot_password_template.html',
  'text!./login_oidc_template.html',

  'session'

], function (Backbone, $, _,
             login_template,
             forgot_password_template,
             login_oidc_template,
             session) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (options) {
      _.extend(this, options);

      this.dataModel = new Backbone.Model();
      this.dataModel.set({ errormessage: this.errormessage });

      this.user = session.get('user');

      this.listenTo(this.user, 'error', function (error) {
        this.loginFailed();
      }, this);

      this.listenTo(this.user, 'change:id', function (user) {
        user.unset('password', {silent: true});
      });

      this.listenTo(this.user, 'change:message', function (user) {
        if (user.get('success')) {
          user.unset('forgot_password', {silent: true});
          this.passwordReset();
        } else {
          this.passwordResetFailed(user.get('message'));
        }
      }, this);

      this.render();

    },
    user: false,
    show_view: 'login',

    template: _.template(login_template),
    forgot_password_template: _.template(forgot_password_template),
    login_oidc_template: _.template(login_oidc_template),

    events: {
      'click .js-login': 'showLogin',
      'click .js-forgot-password': 'showForgotPassword',
      'submit .js-login-form': 'login',
      'submit .js-forgot-password-form': 'submitForgotPasswordForm'
    },

    render: function () {
      if (session.get('oidc') === 'true') {
        this.$el.html(this.login_oidc_template(this.dataModel.toJSON()));
        return this;
      }
      if (this.show_view === 'forgot_password') {
        this.$el.html(this.forgot_password_template());
      } else {
        this.$el.html(this.template());
      }

      return this;
    },

    showForgotPassword: function (e) {
      e.preventDefault();
      this.show_view = 'forgot_password';
      this.render();
    },

    showLogin: function (e) {
      e.preventDefault();
      this.show_view = 'login';
      this.render();
    },

    login: function (e) {
      var username, password,
          $username = this.$('#username'),
          $password = this.$('#password');

      e.preventDefault();

      this.$('.login-error').removeClass('active');

      if (!$username.val()) {
        $username.addClass('input-error');
      } else {
        $username.removeClass('input-error');
        username = $username.val();
      }

      if (!$password.val()) {
        $password.addClass('input-error');
      } else {
        $password.removeClass('input-error');
        password = $password.val();
      }
      if (username && password) {
        this.user.set({
          username: username,
          password: password
        }).save();
      }
    },

    passwordReset: function () {
      this.$('.login-page-content').html(_.t('login.text.password_reset'));
    },

    passwordResetFailed: function (message) {
      this.$('#email').addClass('input-error');
      this.$('.js-forgot-password-form').after('<p>' + message + '</p>');
    },

    loginFailed: function() {
      this.$('#username').addClass('input-error');
      this.$('#password').addClass('input-error');
      this.$('.login-error').addClass('active');
    },

    submitForgotPasswordForm: function (e) {
      var email,
          $email = this.$('#email');

      e.preventDefault();

      this.$('.login-error').removeClass('active');

      if (!$email.val()) {
        $email.addClass('input-error');
      } else {
        $email.removeClass('input-error');
        email = $email.val();
      }

      if (email) {
        this.user.set({
          email: email,
          forgot_password: true
        }).save();
      }
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

